import AnalysisCategory from 'views/Analysis/AnalysisCategory';
import { AnalysisKinds, ComparisonKinds } from 'views/Analysis/analysisUtils';

// 分析（工事区分）
function AnalysisKoujiKbn(props) {
  // 分析情報
  const analysisList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 分析種別
  const analysisKind = AnalysisKinds.find((x) => x.key == props.analysisKind);
  // 比較種別
  const comparisonKind = ComparisonKinds.find((x) => x.key == props.comparisonKind);

  // 集計項目
  const summaryItems = [
    { key: 'KOUJI_KBN3_1_1', label: '造園(新築)' },
    { key: 'KOUJI_KBN3_1_2', label: '造園(ﾘﾌｫｰﾑ)' },
    { key: 'KOUJI_KBN3_1_3', label: '造園(小工事)' },
    { key: 'KOUJI_KBN3_2_1', label: '建築(新築)' },
    { key: 'KOUJI_KBN3_2_2', label: '建築(ﾘﾌｫｰﾑ)' },
    { key: 'KOUJI_KBN3_2_3', label: '建築(小工事)' },
    { key: 'KOUJI_KBN3_3_4', label: 'スポット管理' },
    { key: 'KOUJI_KBN3_3_5', label: '年間管理' },
    { key: 'KOUJI_KBN3_9', label: 'はるな墓苑' },
  ];

  return (
    <AnalysisCategory
      analysisList={analysisList}
      selectedPeriod={selectedPeriod}
      summaryItems={summaryItems}
      analysisKind={analysisKind}
      comparisonKind={comparisonKind}
      categoryName="工事区分別"
    />
  );
}
export default AnalysisKoujiKbn;
